module.exports = __webpack_public_path__ + "files/5965005269a45ca5603f3b08fe7769f2.png";